<template>
    <div>
        <h3 style="padding: 10px 0;">客运监管</h3>
        <el-table :data="tableData" style="width: 100%" border>
            <el-table-column prop="organizationName" label="机构名称" width="140" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="routeName" label="起讫地" show-overflow-tooltip>
            </el-table-column>
            <el-table-column prop="routeType" label="线路类别" width="100">
                <template slot-scope="scope">
                    {{ scope.row.routeType | filterConst('LINECATEGORY') }}
                </template>
            </el-table-column>
            <el-table-column prop="km" label="公里数" width="100">
            </el-table-column>
            <el-table-column prop="transferMode" label="接送模式" width="100">
                <template slot-scope="scope">
                    {{ scope.row.transferMode | filterConst('LINEMODE') }}
                </template>
            </el-table-column>
            <el-table-column prop="openDate" label="开通日期" width="100">
            </el-table-column>
            <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                    <el-button type="text" @click="handleEdit(scope.row)">编辑</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-button type="" @click="addLine" style="margin-top: 10px; width: 100%;">添加线路</el-button>

        <lineSupervise :lineData="surveyLineData" v-model="showSuperviseDialog" @success="handleClose"
            @close="handleClose"></lineSupervise>
    </div>
</template>

<script>
import lineSupervise from './lineSupervise.vue'
export default {
    components: {
        lineSupervise
    },
    data() {
        return {
            tableData: [],
            showSuperviseDialog: false,
            surveyLineData: {}
        }
    },
    created() {
        this.getTableData()
    },
    methods: {
        async getAllLine() {
            this.tableData = await this.mixinGetLines({
                organizationId: ''
            })
        },
        async getTableData() {
            const res = await this.$axios.get('/api/v1/manage/line/survey')
            this.tableData = res.data
        },
        addLine() {
            this.surveyLineData = {}
            this.showSuperviseDialog = true
        },
        handleEdit(row) {
            console.log(row)
            this.surveyLineData = { ...row }
            this.showSuperviseDialog = true
        },
        handleClose() {
            this.getTableData()
            this.$emit('close')
        },
    }
}
</script>

<style></style>